// Exports
export default {
	"description": "description_JIz-J",
	"checkboxWrapper": "checkboxWrapper_QwO19"
};
